import { Text, Box, Stack, useTheme } from '@wegroup/design-system';
import React, { ReactElement } from 'react';

interface Props {
  Illustration: ReactElement;
  inputElement: ReactElement;
  dataTestId?: string;
}

const IllustrationButton: React.FC<React.PropsWithChildren<Props>> = ({
  Illustration,
  inputElement,
  children,
  dataTestId = 'RISK-ANALYSIS_ILLUSTRATION-BUTTON',
  ...otherProps
}) => {
  const { colors } = useTheme();
  return (
    <Stack
      as="label"
      direction={{ base: 'row-reverse', mobileL: 'column' }}
      alignItems={{ base: 'flex-start', mobileL: 'stretch' }}
      maxW="80"
      minW="48"
      spacing="4"
      userSelect="none"
      _hover={{ cursor: 'pointer' }}
      data-test-id={dataTestId}
      _disabled={{
        opacity: '0.5',
      }}
      {...otherProps}
    >
      <Box
        alignSelf="center"
        display={{ base: 'none', mobileL: 'flex' }}
        justifyContent={{ mobileL: 'center' }}
        h="48"
        maxH={{ base: '15vh', tablet: '20vh', laptopL: '25vh' }}
        sx={{ svg: { transition: '0.2s', w: '100%', h: '100%' } }}
      >
        {Illustration}
      </Box>
      <Text
        align={{ mobileL: 'center' }}
        textStyle="h4Headline"
        color="gray.300"
        as="h4"
        flexGrow={{ base: 1, mobileL: 'inherit' }}
        sx={{
          span: {
            transition: '0.2s',
            color: '#222',
          },
        }}
        _checked={{
          span: {
            color: colors.primary[500],
          },
        }}
        {...otherProps}
      >
        {children}
      </Text>
      {inputElement}
    </Stack>
  );
};

export default IllustrationButton;
